module.exports = __webpack_public_path__ + "img/bc32adc.png";